<template>
  <el-config-provider :locale="elementLocale">
    <div class="app-container">
      <NavBar :showTabContainer="showTabContainer" />

      <router-view />

      <template v-if="showFooters">
        <Footers></Footers>
      </template>

      <MaintenancePage :visible="showMaintenance" />

    </div>
  </el-config-provider>
</template>

<script setup>
import { onMounted, ref, watch, nextTick, onUnmounted, computed } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import store from '@/store'
import NavBar from '@/components/NavBar.vue'
import Footers from '@/components/Footers.vue'
import MaintenancePage from './components/MaintenancePage.vue'
import router from '@/router'
import { useI18n } from 'vue-i18n'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import en from 'element-plus/dist/locale/en.mjs'

const { locale, t } = useI18n()

const elementLocales = {
  'zh-CN': zhCn,
  'en-US': en
}

const elementLocale = computed(() => {
  return elementLocales[locale.value] || zhCn
})

// 监听路由变化，根据路由元信息控制是否显示tab
const showTabContainer = ref(true)
// 控制是否显示footer
const showFooters = ref(true)
// 添加一个标志来跟踪对话框是否已经打开
const isDialogVisible = ref(false)
// 添加一个标志来控制维护页面的显示
const showMaintenance = ref(false)

// 监听路由变化
watch(() => router.currentRoute.value, (newPath) => {
  console.log('当前路由路径APP.vue:', newPath)
  // 如果路由元信息中包含navbar为true，则显示tab
  showTabContainer.value = newPath.meta.navbar
  // 如果路由元信息中包含footer为true，则显示footer
  showFooters.value = newPath.meta.footer
})

// 检测是否为移动设备
const isMobile = () => {
  console.log('当前窗口宽度:', window.innerWidth)
  return window.innerWidth < 768;
}

// 显示移动设备提示
const showMobileWarning = async () => {
  nextTick(() => {
    if (isMobile() && !isDialogVisible.value) {
      console.log('是移动设备')
      isDialogVisible.value = true;
      try {
        ElMessageBox.alert(
          '请使用pc登录网站表现更加优越 </br> Please lodge in with pc to get better performance',// Please lodge in with pc to get better performance
          '消息/Message', // Device prompt
          {
            confirmButtonText: ' OK',
            type: 'warning',
            showClose: false,
            draggable: false,
            dangerouslyUseHTMLString: true,
          }
        );
      } catch (error) {
        // 用户点击取消或关闭的处理
        console.log('用户关闭了提示框');
      } finally {
        // 无论成功还是失败，都重置对话框状态
        isDialogVisible.value = false;
      }
    }
  })
}

// 应用初始化
const initializeApp = async () => {
  try {
    // 检查是否有保存的登录状态
    if (store.state.token) {
      // 可以在这里添加额外的初始化逻辑，如获取用户信息等
      console.log('应用初始化：用户已登录')
    } else {
      console.log('应用初始化：用户未登录')
    }

    // 初始化时检查是否为移动设备
    showMobileWarning();
  } catch (error) {
    console.error('应用初始化失败:', error)
    ElMessage.error(t('app.initFailed'))
  }
}

// 处理显示维护页面的事件
const handleShowMaintenance = () => {
  console.log('触发显示维护页面事件')
  showMaintenance.value = true;
};

// 测试维护页面显示的方法（仅用于测试）
const testMaintenancePage = () => {
  // 直接触发事件或调用处理函数
  window.dispatchEvent(new CustomEvent('showMaintenancePage'));
};

onMounted(() => {
  // 应用启动时检查登录状态
  initializeApp();
  // 监听自定义事件
  window.addEventListener('showMaintenancePage', handleShowMaintenance);
});

onUnmounted(() => {
  // 清理事件监听器
  window.removeEventListener('showMaintenancePage', handleShowMaintenance);
});
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  padding: 0;
  margin: 0;
  min-width: 800px;
}

html,
body,
div {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

.app-container {
  width: 100vw;
  height: 100vh;
}

/* 主内容区域 */
.main-content {
  width: 100%;
  min-width: 800px;
  height: calc(100vh - 60px);
  overflow: hidden;
}

.main {
  height: 100%;
  height: calc(100vh - 60px);
}
</style>
